import { Engine } from 'engine/Engine';
import { V2 } from 'engine/lib/V2';
import { Facet } from './Facet';

export interface SpriteFrameset {
  frames: React.ReactNode[],
  fps: number,
}

export const spriteSheet = <T extends Partial<Record<string, SpriteFrameset>>>(t: T): T => t;

export interface SpriteFacetProps {
  frameset: SpriteFrameset,
  offset?: V2,
  opacity?: number,
}

export class SpriteFacet extends Facet<SpriteFacetProps> {

  private lastFrameChange = -1;

  frame = 0;

  set(frameset: SpriteFrameset) {
    if (this.props.frameset !== frameset) {
      this.frame = 0;
      this.lastFrameChange = -1;
      this.props.frameset = frameset;
    }
  }

  update(delta: number, { time }: Engine) {
    if (this.props.frameset.fps === 0) return;
    const frameDuration = 1000 / this.props.frameset.fps;
    if (this.lastFrameChange === -1) {
      this.lastFrameChange = time.now;
    }
    const nextFrameChange = this.lastFrameChange + frameDuration;
    if (time.now >= nextFrameChange) {
      this.frame = (this.frame + 1) % this.props.frameset.frames.length;
      this.lastFrameChange = nextFrameChange;
    }
  }
}
